module.exports = __webpack_public_path__ + "img/logo_alt@2x.0f8baaf3.png";